import React, { useEffect, useState } from 'react'
import { Pagination } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { API, API_ROUTER } from '../../../../api'

import EventItem from '../../../../components/list-items/components/eventItem'
import { Preloader } from '../../../../components/UI'

import styles from './styles.module.scss'

export const EventsList = () => {
  const [eventsList, setEventsList] = useState()
  const [pageEvents, setPageEvents] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  const getEventsList = () => {
    let urlParams = {}
    setIsLoading(true)

    API.request({
      ...API_ROUTER.follow.getfollowedEvents,
      urlParams,
      pathKeys: {
        page: pageEvents,
        limit: 10,
      },
    })
      .then(res => {
        setEventsList(res)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  const handleChangeEvents = (event, value) => {
    setPageEvents(value)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    getEventsList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageEvents])

  if (isLoading) {
    return <Preloader />
  }

  return (
    <section className={styles.calendarList}>
      {eventsList?.follows?.map(events => (
        <EventItem {...events} key={events.id} />
      ))}

      {!eventsList?.follows?.length && (
        <div className='empty-data'>
          <FormattedMessage id='calendar.noEvents' />
        </div>
      )}

      {!eventsList?.paginator?.hasNextPage |
        (eventsList?.follows?.length > 9) && (
        <div className={styles.paginatorWrapper}>
          <Pagination
            classes={{ ul: styles.pagination }}
            count={eventsList?.paginator?.lastPage}
            page={eventsList?.paginator?.currentPage}
            onChange={handleChangeEvents}
            variant='outlined'
          />
        </div>
      )}
    </section>
  )
}

export default EventsList
